<template>
    <v-card>

        <v-card-title>
            <div class="title font-weight-light">Finalizar Atención</div>
        </v-card-title>

        <v-card-text>
            ¿Desea finalizar la atención?
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="$emit('cancel')">Cancelar</v-btn>
            <v-btn depressed
                   @click="confirm"
                   :loading="loading"
                   color="primary">Confirmar</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
    export default{
        props:{
            event: {
                type: Object
            },
            loading:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                derivationType: 'discharge'
            }
        },
        methods:{
            confirm(){
                var vm = this
                vm.$emit('confirm', {
                    derivation: {
                        type: vm.derivationType
                    }
                })
            }
        }
    }
</script>